
import Gutter from '@/ui-kit/components/gutter';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import {
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import SummaryFeature from './summary-feature';
import { ListingSummaryFeature } from './enums';
import { EXCLUDED_COMMUNITY_NONE_VALUE } from './constants';

export default {
  name: 'ListingSummary',
  components: {
    Typography,
    SummaryFeature,
    Gutter,
  },
  props: {
    address: {
      default: '',
      type: String,
    },
    postalCode: {
      default: '',
      type: String,
    },
    price: {
      default: '',
      type: String,
    },
    marketDataLink: {
      default: '',
      type: String,
    },
    analyticsOrigin: {
      default: '',
      type: String,
    },
    [ListingSummaryFeature.Beds]: {
      default: 0,
      type: Number,
    },
    [ListingSummaryFeature.Baths]: {
      default: 0,
      type: Number,
    },
    [ListingSummaryFeature.Sqft]: {
      default: 0,
      type: Number,
    },
    [ListingSummaryFeature.Community]: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      StyleSizeType,
      TypographyType,
      StylePositionType,
      StyleColorSchemeType,
      StyleFontWeightType,
    };
  },
  computed: {
    fullAddress() {
      return `${this.address} ${this.postalCode}`;
    },
    features() {
      return Object.entries(ListingSummaryFeature)
        .map(([title, value]) => (
          value === ListingSummaryFeature.Community
            ? {
              title,
              value: this[value] !== EXCLUDED_COMMUNITY_NONE_VALUE && this[value],
              link: this.marketDataLink,
            }
            : { title, value: this[value] }))
        .filter(({ value }) => value);
    },
  },
};
